module.exports = __webpack_public_path__ + "img/bi.5892be5c.svg";